import pick from 'lodash/pick';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import get from 'lodash/get';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import { date } from 'src/common/utils/date-time-formatter';

const formatShippingAddress = (countriesList, address) => {
  // pick only certain keys from address
  const getCountry = countriesList.find(country => country.code === address.country);
  const filteredAddress = pick(address, ['address1', 'address2', 'zipcode', 'city', 'country']);
  // remove empty keys from adderss object
  let emptyValuesOmitted = omitBy(filteredAddress, (value) => !value || isNil(value));
  const formattedAddress = {
    ...emptyValuesOmitted,
    country: get(getCountry, 'name', ''),
  };

  return Object.values(formattedAddress).join(', ');
};

export const buildContent = (item, props) => {
  switch (item.fieldType) {
    case 'contact':
      return get(props, 'orderDetails.email', '');
    case 'shipping':
      const countriesList = get(props.globalContent, 'country.countryOption') || [];
      return formatShippingAddress(countriesList, get(props, 'orderDetails.shippingAddress') || {});
    case 'speed':
      const selectedShipment = get(props, 'orderDetails.selectedShipment') || {};
      const methodName = get(selectedShipment, 'method.name', '');
      const methodType = get(selectedShipment, 'method.type', '');
      const deliveryDates = selectedShipment.delivery || {};

      const checkoutBody = get(props.globalContent, 'checkout.body') || [];
      const contactShippingSlice = checkoutBody.find(slice => slice.sliceType === 'contact_and_shipping') || {};
      const contactShippingItems = contactShippingSlice.items || [];
      const contentItem = contactShippingItems.find(item => item.fieldType === 'speed') || {};
      const methodItem = contactShippingItems.find(item => (
        item.fieldType.includes('speed') &&
        item.fieldType.includes(methodType)
      )) || {};

      const text = contentItem.content || '';
      const shippingTitle = methodItem.content || '';
      let dates = {};

      for (let day in deliveryDates) {
        if (deliveryDates.hasOwnProperty(day)) {
          dates[day] = date(deliveryDates[day], props.country, {
            weekday: 'long',
            month: 'long',
            day: 'numeric'
          });
        }
      }

      if (!text) {
        return `${methodName} (${dates.latest})`;
      }
      return replaceTextWithValues(text, { shippingTitle, ...dates });
  }
};

export const buildUrl = (item, props) => {
  let path = 'address';
  if (item.fieldType === 'speed') {
    path = 'delivery';
  }
  return localiseUrl(props.country, `/checkout-v2/${path}?return_to=${props.location.pathname}`);
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/ContactAndShipping/helpers.js